import { Pipe, PipeTransform } from '@angular/core';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { ANONYMIZED_VALUES, CANDIDATES_RIGHTS } from 'projects/admin/src/app/shared/constants';

@Pipe({
  name: 'anonymizedCandidate'
})
export class AnonymizedCandidatePipe implements PipeTransform {

  constructor(
    private auth: AuthStateService
  ) {}

  transform(value: string): string {
    return this.auth.getAnonymizedValue(value);
  }

}
